import { MerchFlowCoreRange } from "../merchandise";
import type { PsaAisleSplitSuggestion } from "@CommonUtils/psa/aisleSplitGap";

export const RoutePostMerchflowsImportPlanogramsFromPsa = "/merchflows/import-planograms-from-psa";

export interface PayloadFormPostMerchflowsImportPlanogramsFromPsa {
  psaFiles: File[];
  merchflowName: string;
  notes?: string;
  goLiveDate: string;
  coreRangeOption: MerchFlowCoreRange;
  deactivationDate?: string | null;
  /** Sub-Category on UI */
  categoryCode: string;
  /** Category on UI, category_group in DB */
  retailerCategoryCode: string;
}

export type PayloadPostMerchflowsImportPlanogramsFromPsa = FormData;

export interface ResponsePostMerchflowsImportPlanogramsFromPsa {
  merchflow_id: number;
  merchflow_name: string;
  total_stores: number;
  successful_stores: number;
  failed_stores: number;
  store_results: Array<{
    store_code: string;
    /** The store this row is for; null when the file names no store this category knows. */
    store_id: number | null;
    /** The category the import ran for; null when the file failed before it resolved. */
    category_id: number | null;
    file_name: string;
    status: "SUCCESS" | "ERROR";
    error?: string;
    product_sync?: {
      products_not_found: number;
      products_updated: number;
      fields_updated: number;
    };
    /** Seams the PSA suggests may be aisle breaks, minus any the store's fixtures already declare. */
    aisle_break_suggestions?: PsaAisleSplitSuggestion[];
  }>;
}
